import isEqual from 'lodash/isEqual';

const findFirstInObject = (tree, childrenKey, objToFindBy) => {
  let treeToReturn = tree;
  let found = false;
  const findKeys = Object.keys(objToFindBy);
  findKeys.forEach(key => {
    isEqual(tree[key], objToFindBy[key]) ? (found = true) : (found = false);
  });
  if (found) {
    return tree;
  }
  const findInChildren = (obj, childrenKey, objToFindBy, parent) => {
    let foundInChild = false;
    if (obj.hasOwnProperty(childrenKey)) {
      for (let i = 0; i < obj[childrenKey].length; i++) {
        // eslint-disable-next-line no-loop-func
        findKeys.forEach(key => {
          isEqual(obj[childrenKey][i][key], objToFindBy[key])
            ? (foundInChild = true)
            : (foundInChild = false);
        });
        if (foundInChild) {
          found = true;
          treeToReturn = Object.assign({}, obj[childrenKey][i], { parent: obj });
          break;
        }
      }
      if (!foundInChild && !found) {
        obj[childrenKey].forEach(child => findInChildren(child, childrenKey, objToFindBy, obj));
      }
    }
    return obj;
  };
  findInChildren(tree, childrenKey, objToFindBy, { parent: treeToReturn });
  return found ? treeToReturn : false;
};

export default findFirstInObject;
